const AppHeader = () => {
    return (
        <div className="bg-slate-100 w-full flex justify-center p-5 shadow-xl sticky top-0 z-10">
            <img src="/logo.png" alt="Cenco Consultoría" className="w-80" />
            <h1 className="text-xl absolute text-slate-600 mt-14 ml-36 animate-bounce">
                Cartera de aplicaciones
            </h1>
        </div>
    );
}

export default AppHeader;
